const session_id = Math.random().toString(36).substr(2, 16) + (new Date).getTime().toString(36);
export default session_id;


// WEBPACK FOOTER //
// ./session_id.js